import React, { useCallback, useEffect, useState } from "react";
import { useCodelist } from "../../hooks/useCodelist";
import FormFields from "./vendorFields.json";
import { initialPaginationModelValues } from "../../constants/paginationConstants";
import { GridSortModel } from "@mui/x-data-grid-pro";
import { debounce } from "lodash";
import { useVendors } from "../../hooks/useVendors";
import VendorsList from "./VendorsList";
import { useParams } from "react-router-dom";

const VendorsPage: React.FunctionComponent<any> = () => {
  const params = useParams();
  const [rowsCount, setRowsCount] = useState<number>(0);
  const [paginationModel, setPaginationModel] = useState(
    initialPaginationModelValues
  );
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "vendor_id", sort: "asc" },
  ]);
  const [filterVal, setFilterVal] = useState("");
  const {
    getAllVendors,
    allVendorsData,
    allVendorsIsLoading,
    allVendorsIsSuccess,
  } = useVendors();
  const [vendorsList, setVendorsList] = useState<any[]>([]);
  const handleSortModelChange = useCallback(
    debounce((model: GridSortModel) => {
      setSortModel(model);
    }, 300),
    []
  );
  const getAllVendorsFunc = async (
    from: number,
    size: number,
    filterValue?: any
  ) => {
    await getAllVendors({
      study_id: params?.study_id,
      from,
      size,
      value:
        filterValue && filterValue?.quickFilter ? filterValue?.quickFilter : "",
      sort_by: sortModel?.[0]?.field,
      sort_order: sortModel?.[0]?.sort,
      data:filterValue && filterValue?.advanceFilter 
    });
  };

  const { getCodelistData, codelistData } = useCodelist();

  useEffect(() => {
    getCodelistData({ data: { code_list_codes: FormFields.CODES } });
  }, []);

  useEffect(() => {
    if (codelistData) {
      FormFields.vendorFields.map((obj) => {
        if (obj.name == "country") {
          obj.options = codelistData?.find(
            (item: any) => item.CNTRY?.length > 0
          ).CNTRY;
        }
      });
    }
  }, [codelistData]);

  useEffect(() => {
    if (paginationModel?.pageSize) {
      const { page, pageSize } = paginationModel;
      if (page * pageSize > rowsCount - 1) {
        getAllVendorsFunc(0, pageSize, filterVal);
      } else {
        getAllVendorsFunc(page * pageSize, pageSize, filterVal);
      }
    }
  }, [paginationModel, filterVal, sortModel]);

  useEffect(() => {
    if (allVendorsData && allVendorsIsSuccess) {
      setRowsCount(allVendorsData?.count);
      const data = allVendorsData?.result?.map((ele: any) => {
        return {
          ...ele,
          id: ele?.vendor_id,
        };
      });
      setVendorsList(data);
    } else if (allVendorsData?.count == 0) {
      setRowsCount(0);
      setVendorsList([]);
    }
  }, [allVendorsData, allVendorsIsSuccess]);

  return (
    <>
      <VendorsList
        vendorsList={vendorsList}
        rowsCount={rowsCount}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        allVendorsIsLoading={allVendorsIsLoading}
        setFilterVal={setFilterVal}
        filterVal={filterVal}
        getAllVendorsFunc={getAllVendorsFunc}
        sortModel={sortModel}
        handleSortModelChange={handleSortModelChange}
        codelistData={codelistData}
      />
    </>
  );
};

export default VendorsPage;
